import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import DocumentTypeForm from '../../../components/forms/DocumentTypeForm';
import { useDocumentTypeApi } from '../../../hooks/useDocumentTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { DocumentTypeDTO } from '../../../services/apiClient';

const DocumentTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useDocumentTypeApi();
  const [entityData, setEntityData] = useState<DocumentTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Document Types', href: '/admin/documenttypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching DocumentType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/documenttypes');
    } catch (error) {
      console.error('Error updating DocumentType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/documenttypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.DocumentType.Edit'
    >
        {entityData ? (
          <DocumentTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/documenttypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default DocumentTypeEdit;